import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { PaginationContexts } from '../../App'
import logoImage from '../../assets/lws.svg'
import searchImage from '../../assets/search.svg'
import { fetchVideos } from '../../features/videos/videosSlice'
import Search from './Search'

export default function Navbar() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { setSelected } = useContext(PaginationContexts)
  const handleInitState = () => {
    navigate('/', { replace: true })
    setSelected(0)
    dispatch(fetchVideos({ tags: [], search: '', page: 1, limit: 8 }))
  }
  return (
    <nav className="bg-slate-100 shadow-md">
      <div className="max-w-7xl mx-auto px-5 lg:px-0 flex justify-between py-3">
        <button onClick={() => handleInitState()}>
          <img className="h-10" src={logoImage} alt="Learn with Sumit" />
        </button>
        <div className="border border-slate-200 flex items-center bg-white h-10 px-5 rounded-lg text-sm ring-emerald-200">
          <Search />
          <img className="inline h-4 cursor-pointer" src={searchImage} alt="Search" />
        </div>
      </div>
    </nav>
  )
}
